export enum JobStatus {
  QUEUED = -1,
  IN_PROGRESS = -2,
  DONE = -3,
  FAILED = -4,
}
